var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.723807 11.6464C0.919069 11.8417 1.23565 11.8417 1.43091 11.6464L5.64645 7.43091C5.84171 7.23565 6.1583 7.23565 6.35356 7.43091L10.5691 11.6464C10.7644 11.8417 11.0809 11.8417 11.2762 11.6464L11.6465 11.2762C11.8417 11.0809 11.8417 10.7643 11.6465 10.5691L7.43092 6.35355C7.23566 6.15829 7.23566 5.84171 7.43092 5.64645L11.6465 1.43091C11.8417 1.23565 11.8417 0.919068 11.6465 0.723805L11.2762 0.353553C11.0809 0.158291 10.7644 0.158291 10.5691 0.353553L6.35356 4.56909C6.1583 4.76435 5.84171 4.76435 5.64645 4.56909L1.43091 0.353553C1.23565 0.158291 0.919068 0.158291 0.723806 0.353553L0.353554 0.723805C0.158291 0.919068 0.158292 1.23565 0.353554 1.43091L4.56909 5.64645C4.76435 5.84171 4.76435 6.15829 4.56909 6.35355L0.353554 10.5691C0.158292 10.7643 0.158291 11.0809 0.353554 11.2762L0.723807 11.6464Z",
    fill: "#97979B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.860dddafcdc3ac31006ac517e338a4c4.svg";
export { ForwardRef as ReactComponent };